import React, { Component } from "react";
import Card from "material-ui/Card";
import { FormControl } from "material-ui/Form";
import Input, { InputLabel } from "material-ui/Input";
import { MenuItem } from "material-ui/Menu";
import Select from "material-ui/Select";
import Button from "material-ui/Button";
import { push } from "react-router-redux";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withStyles } from "material-ui/styles";
import { changeEnableMap } from "../../../modules/map";
import HeaderCard from "../HeaderCard/HeaderCard";
import "./SelectCity.css";

const styles = () => ({
  button: {
    border: "1px #3f51b5 solid",
    borderRadius: "5px",
    marginTop: "15px",
    alignSelf: "flex-end"
  }
});

class SelectCity extends Component {
  constructor() {
    super();
    this.state = {
      selectedCityId: "",
      shouldOpenDialog: false
    };
  }

  componentDidMount() {
    this.props.changeEnableMap(false, {});
  }

  handleChangeCity = event => {
    this.setState({ selectedCityId: event.target.value });
  };

  handleOpenInfoDialog = () => {
    this.setState({ shouldOpenDialog: true });
  };

  handleCloseInfoDialog = () => {
    this.setState({ shouldOpenDialog: false });
  };

  render() {
    const { classes, cities } = this.props;
    return (
      <div className="main-card">
        <Card>
          <HeaderCard
            isCity={false}
            subtitle="Redécouvrez votre ville grâce aux itinéraires alternatifs de MoodWalkR !"
            openInfoDialog={this.handleOpenInfoDialog}
          />
          <div className={!this.props.menuIsOpen ? "no-display" : ""}>
            <form className="main-content" autoComplete="off">
              <FormControl fullWidth margin="normal">
                <InputLabel htmlFor="city">
                  Sélectionnez une des villes disponibles
                </InputLabel>
                <Select
                  value={this.state.selectedCityId}
                  onChange={this.handleChangeCity}
                  input={<Input id="city" />}
                >
                  {cities.map(city => (
                    <MenuItem key={city.id} value={city.id}>
                      {city.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Button
                onClick={() =>
                  this.state.selectedCityId !== "" &&
                  this.props.changePage(
                    `@${cities
                      .find(city => city.id === this.state.selectedCityId)
                      .name.toLowerCase()}`
                  )
                }
                className={classes.button}
                color="primary"
              >
                Valider
              </Button>
            </form>
          </div>
        </Card>
      </div>
    );
  }
}

SelectCity.propTypes = {
  changePage: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    button: PropTypes.string
  }).isRequired,
  cities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    })
  ).isRequired,
  changeEnableMap: PropTypes.func.isRequired,
  menuIsOpen: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  cities: state.search.cities,
  menuIsOpen: state.search.menuIsOpen
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: city => push(`/${city}`),
      changeEnableMap
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(SelectCity)
);



// WEBPACK FOOTER //
// ./src/containers/MainCard/SelectCity/SelectCity.jsx